<div class="container-fluid py-4">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h2><i class="bi bi-list-ul text-warning me-2"></i>{{ 'reservations.title_my' | translate }}</h2>
      <p class="text-muted mb-0">{{ 'reservations.title_my_subtitle' | translate }}</p>
    </div>
    <button class="btn btn-accent" (click)="createReservation()">
      <i class="bi bi-plus me-2"></i>{{ 'reservations.title_new' | translate }}
    </button>
  </div>

  <!-- Filters -->
  <div class="card mb-4">
    <div class="card-body">
      <div class="row g-3 align-items-end">
        <div class="col-md-3">
          <label class="form-label">{{ 'reservations.filter_status' | translate }}</label>
          <s-select name="filter_status" [items]="statusOptions" bindValue="value" bindLabel="label"
            [(model)]="filters.status" (change)="applyFilters()">
          </s-select>
        </div>
        <div class="col-md-3">
          <label class="form-label">{{ 'reservations.filter_vehicle' | translate }}</label>
          <s-select name="filter_vehicle" [items]="vehicleTypeOptions" bindValue="value" bindLabel="label"
            [(model)]="filters.vehicle_type" (change)="applyFilters()">
          </s-select>
        </div>
        <div class="col-md-2">
          <label class="form-label">{{ 'reservations.filter_from' | translate }}</label>
          <s-input type="date" name="filter_from" [(model)]="filters.date_from" (onChange)="applyFilters()"></s-input>
        </div>
        <div class="col-md-2">
          <label class="form-label">{{ 'reservations.filter_to' | translate }}</label>
          <s-input type="date" name="filter_to" [(model)]="filters.date_to" (onChange)="applyFilters()"></s-input>
        </div>
        <div class="col-md-2">
          <button class="btn btn-outline-primary w-100" (click)="clearFilters()">
            <i class="bi bi-x me-1"></i>{{ 'filter_reset' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty -->
  <div *ngIf="reservationsLoaded && reservations.length === 0" class="empty-state card align-items-center">
    <i class="bi bi-calendar-x"></i>
    <h4>{{ 'reservations.empty_title' | translate }}</h4>
    <p class="text-muted">{{ 'reservations.empty_text' | translate }}</p>
    <button class="btn btn-accent w-auto" (click)="createReservation()">
      <i class="bi bi-plus me-2"></i>{{ 'reservations.title_new' | translate }}
    </button>
  </div>

  <!-- Table -->
  <div class="card p-2" *ngIf="reservations.length > 0">
    <div class="table-responsive">
      <table class="table table-hover rep-table mb-0">
        <thead>
          <tr>
            <th>{{ 'reservations.date' | translate }}</th>
            <th>{{ 'reservations.location' | translate }}</th>
            <th>{{ 'reservations.station' | translate }}</th>
            <th>{{ 'reservations.license_plate' | translate }}</th>
            <th>{{ 'reservations.energy' | translate }}</th>
            <th>{{ 'status.status' | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let res of reservations" class="cursor" (click)="viewReservation(res.id_reservation!)">
            <td>
              <strong>{{ formatDateTime(res.date_from) }}</strong>
              <div class="small text-muted">{{ 'reservations.until' | translate }} {{ formatDateTime(res.date_to!) }}</div>
            </td>
            <td>{{ res.location_name }}</td>
            <td>{{ res.station_name }}</td>
            <td><code>{{ res.license_plate }}</code></td>
            <td><span class="badge badge-primary">{{ res.energy_kwh }} kWh</span></td>
            <td><span class="badge" [ngClass]="getStatusClass(res.status!)">{{ ('reservation_status.' + res.status) | translate }}</span></td>
            <td><i class="bi bi-chevron-right text-muted"></i></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-footer d-flex justify-content-between align-items-center" *ngIf="totalCount > pageSize">
      <span class="text-muted">{{ (page - 1) * pageSize + 1 }} - {{ Math.min(page * pageSize, totalCount) }} z {{ totalCount }}</span>
      <ngb-pagination [collectionSize]="totalCount" [(page)]="page" [pageSize]="pageSize" (pageChange)="onPageChange($event)" [maxSize]="5"></ngb-pagination>
    </div>
  </div>
</div>
